<template>
  <Modal modalType="ImageUpload" mayCancel="true" v-on:cancel="onCancel">
    <h2>Upload Image or PDF</h2>
    <form class="PForm" enctype="multipart/form-data">
      <p>
        <input
          type="file"
          multiple
          accept="image/*, application/pdf"
          :disabled="uploadState === 'uploading'"
          @change="onChangeImageUpload"
        />
        <span v-if="uploadState === 'uploading'">Uploading…</span>
      </p>
      <p v-if="uploadState == 'failure'">{{ uploadError }}</p>
      <div class="ButtonRow-FlexSpaceBetween">
        <button class="WBMBigButton" v-on:click="onCancel">Cancel</button>
        <div></div>
        <!-- <button class="WBMBigButton m-primary">Upload</button> -->
      </div>
    </form>
  </Modal>
</template>

<script lang="ts">
import { Component, Emit } from "vue-property-decorator";
import Modal from "@/components/Modal.vue";
import { ModalType } from "@/store/ModalType";
import WBComponent from "@/WBComponent";
import { ModalMutations } from "@/store/modules/modal";

// 16384 is the magic number at which the browser can't composite quickly.

@Component({ components: { Modal } })
export default class ImageUploadModal extends WBComponent {
  uploadState: "initial" | "uploading" | "failure" = "initial";
  uploadError = "";

  mounted() {
    if (!this.wbcontroller?.imageUploadController?.moderationGate()) {
      ModalMutations.closeModal(this.$store.commit, ModalType.ImageUpload);
    }
  }

  reset() {
    this.uploadState = "initial";
    this.uploadError = "";
  }

  onChangeImageUpload(e: Event) {
    const files = (e.target as HTMLInputElement)?.files;
    if (!this.wbcontroller || !files) return;
    this.uploadState = "uploading";
    const imageUploadController = this.wbcontroller.imageUploadController;
    if (!imageUploadController) {
      ModalMutations.closeModals(this.$store.commit);
      return;
    }
    imageUploadController.mousePosition = this.wbcontroller.camera.origin;

    this.wbcontroller.imageUploadController
      ?.handleBlobs(new Array(...files))
      .then(() => {
        ModalMutations.closeModals(this.$store.commit);
      })
      .catch((e) => {
        this.uploadError = e.message;
        this.uploadState = "failure";
      });
  }

  onSubmit() {}

  @Emit("cancel")
  onCancel() {
    ModalMutations.closeModals(this.$store.commit);
  }
}
</script>

<style scoped lang="scss"></style>
